document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);

  // New horizontal scrolling functionality
  let teamExperienceDeveloperScroll = document.getElementById(
    "team-experience-developer-scroll"
  );
  let horizontalSection = document.querySelector(".horizontal-sliders");
  let slides = document.querySelectorAll(".slide");
  let totalScrollDistance = slides.length;
  let slideWidth = slides[0].offsetWidth;
  let slideGap = 20;
  totalScrollDistance = slideWidth + slideGap + 50;

  // Calculate and set height for the pinned section
  const totalHeight = teamExperienceDeveloperScroll.offsetHeight;
  let additionalHeight;
//   if (window.innerWidth <= 1440) {
//     additionalHeight = 100; // Add 100px for screens up to 1440px
//   } else {
//     additionalHeight = 20; // Add 20px for screens larger than 1440px
//   }
  
  const finalHeight = totalHeight + additionalHeight;
//   console.log('Screen width:', window.innerWidth);
//   console.log('Element height:', totalHeight);
//   console.log('Additional height:', additionalHeight);
//   console.log('Final height:', finalHeight);
  
//   // Set the height with responsive padding
//   gsap.set(teamExperienceDeveloperScroll, {
//     height: finalHeight + 'px',
//     maxHeight: finalHeight + 'px'
//   });

  // Get pagination dots
  const dots = document.querySelectorAll('.dot');
  
  // Update active dot based on scroll progress
  function updateDots(progress) {
    const index = Math.round(progress * (slides.length - 1));
    dots.forEach((dot) => dot.classList.remove('active'));
    if (dots[index]) dots[index].classList.add('active');
  }

  // Create ScrollTrigger for horizontal scrolling
  const scrollTween = gsap.to(horizontalSection, {
    x: () => horizontalSection.scrollWidth * -1,
    xPercent: 100,
    ease: "none",
    scrollTrigger: {
      id: "horizontal-scroll",
      trigger: horizontalSection,
      start: "top 30%",
      end: `+=${totalScrollDistance * slides.length}`,
      pin: teamExperienceDeveloperScroll,
      scrub: true,
      invalidateOnRefresh: true,
      onUpdate: (self) => {
        updateDots(self.progress);
      },
    },
  });

  // Pagination dots are for visual progress only - no click functionality

  // Custom Mouse Follower
  const scrollEl = document.querySelector(".desktop-horizontal-scroll");
  const follower = document.getElementById("customMouseFollower");
  let lastScrollLeft = 0;

  if (scrollEl && follower) {
    // Hide default cursor on hover - only on horizontal-container
    const horizontalContainer = document.querySelector(".horizontal-container");

    // Track mouse position globally
    let mouseX = 0;
    let mouseY = 0;

    document.addEventListener("mousemove", (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    });

    // Check if cursor is already over the container on page load
    function checkCursorPosition() {
      const rect = horizontalContainer.getBoundingClientRect();

      if (
        mouseX >= rect.left &&
        mouseX <= rect.right &&
        mouseY >= rect.top &&
        mouseY <= rect.bottom
      ) {
        // Cursor is over the container, show follower
        follower.style.display = "block";
        follower.style.transform = "scale(1)";
        follower.style.opacity = "1";
        horizontalContainer.style.cursor = "none";

        // Position the follower at current mouse position
        const left = mouseX - rect.left + "px";
        const top = mouseY - rect.top + "px";
        follower.style.left = left;
        follower.style.top = top;
      }
    }

    // Check cursor position on page load
    setTimeout(checkCursorPosition, 100);

    horizontalContainer.addEventListener("mouseenter", () => {
      follower.style.display = "block";
      follower.style.transform = "scale(0)";
      follower.style.opacity = "0";
      horizontalContainer.style.cursor = "none";
      setTimeout(() => {
        follower.style.transform = "scale(1)";
        follower.style.opacity = "1";
      }, 10);
    });

    horizontalContainer.addEventListener("mouseleave", () => {
      follower.style.transform = "scale(0)";
      follower.style.opacity = "0";
      horizontalContainer.style.cursor = "";
    });

    // Move follower with mouse
    horizontalContainer.addEventListener("mousemove", (e) => {
      const rect = scrollEl.getBoundingClientRect(); // Use desktop-horizontal-scroll for positioning
      const left = e.clientX - rect.left + "px";
      const top = e.clientY - rect.top + "px";
      follower.style.left = left;
      follower.style.top = top;
    });

    // Rotate arrow based on GSAP ScrollTrigger progress
    let lastProgress = 0;

    // Listen for wheel events on horizontal-container
    horizontalContainer.addEventListener("wheel", (e) => {
      // Use deltaY for horizontal scroll detection (shift + wheel)
      if (e.deltaY < 0) {
        follower.querySelector("img").style.transform = "rotate(180deg)";
      } else if (e.deltaY > 0) {
        follower.querySelector("img").style.transform = "rotate(0deg)";
      }
    });

    // Listen for GSAP ScrollTrigger updates
    if (window.gsap && window.ScrollTrigger) {
      ScrollTrigger.addEventListener("scroll", () => {
        const scrollTrigger = ScrollTrigger.getById("horizontal-scroll");
        if (scrollTrigger) {
          const currentProgress = scrollTrigger.progress;

          if (currentProgress < lastProgress) {
            follower.querySelector("img").style.transform = "rotate(180deg)";
          } else if (currentProgress > lastProgress) {
            follower.querySelector("img").style.transform = "rotate(0deg)";
          }
          lastProgress = currentProgress;
        }
      });
    }

    // Also listen for actual scroll events on the container
    let lastScrollLeft = 0;
    horizontalContainer.addEventListener("scroll", () => {
      const currentScrollLeft = horizontalContainer.scrollLeft;

      if (currentScrollLeft < lastScrollLeft) {
        follower.querySelector("img").style.transform = "rotate(180deg)";
      } else if (currentScrollLeft > lastScrollLeft) {
        follower.querySelector("img").style.transform = "rotate(0deg)";
      }
      lastScrollLeft = currentScrollLeft;
    });
  }

  // Mobile Swiper Initialization
  function initSwiperWhenReady() {
    if (window.Swiper) {
      const swiper = new Swiper(".team-experience-swiper", {
        slidesPerView: 1.5,
        spaceBetween: 11.75,
        pagination: {
          el: ".team-experience-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return `<span class="${className}">${(index + 1)
              .toString()
              .padStart(2, "0")}</span>`;
          },
        },
        breakpoints: {
          100: { slidesPerView: 1.22, spaceBetween: 11.75 },
          575: { slidesPerView: 1.4, spaceBetween: 11.75 },
          800: { slidesPerView: 2.5, spaceBetween: 11.75 },
          1200: { slidesPerView: 3, spaceBetween: 30 },
        },
      });
    } else {
      setTimeout(initSwiperWhenReady, 50);
    }
  }

  // Desktop functionality (mouse follower only - scrolling handled above)
  function initDesktopHorizontalScroll() {
    // This function now only handles mouse follower functionality
    // The horizontal scrolling is handled in the main function above
    console.log("Desktop functionality initialized");
  }

  // Initialize based on screen size
  function initBasedOnScreenSize() {
    if (window.innerWidth > 991) {
      initDesktopHorizontalScroll();
    } else {
      initSwiperWhenReady();
    }
  }

  // Initial setup
  initBasedOnScreenSize();

  // Handle resize
  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      // Kill existing ScrollTrigger instances
      if (window.ScrollTrigger) {
        ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
      }

      // Reinitialize based on new screen size
      initBasedOnScreenSize();
    }, 250);
  });
});
